import { FormGroup } from '@angular/forms';
import { AfterViewInit, Component, ElementRef, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';

@Component({
  selector: 'app-textarea-with-editor',
  templateUrl: './textarea-with-editor.component.html',
  styleUrls: ['./textarea-with-editor.component.scss']
})
export class TextareaWithEditorComponent implements OnInit, OnDestroy, AfterViewInit {

  @Input() label: string;
  @Input() height: number;
  @Input() maxLength: number;
  @Input() controlName: string;
  @Input() form: FormGroup;
  @Input() required = false;
  @Input() private service;

  private content: string;
  private isContentSelected = false;
  public contentLength: number;
  public renderLabel = false;
  public init: any = {
  };
  public editorInFocus = false;

  @ViewChild('editorLabel') private editorLabel:ElementRef;

  ngOnInit(): void {
    this.form.markAsPristine();
    this.form.markAsUntouched();
    

    this.init = {
      entity_encoding: 'raw',
      verify_html: false,
      height: this.height ? this.height : 200,
      menubar: false,
      isContentSelected: this.isContentSelected,
      plugins: [
        'link', 'wordcount'
      ],
      toolbar: 'bold italic underline removeformat | link',
      toolbar_location: 'bottom',
      language_url: 'assets/tinymce/langs/pt_BR.js',
      language: 'pt_BR',
      statusbar: false,
      fixed_toolbar_container: '#RbCustomTinyToolbar',
      branding: false,
      relative_urls: false,
      remove_script_host: false,
      setup: (editor) => {

        editor.on('init', (event) => {
          this.renderLabel = true;
          
          this.form.controls[this.controlName].valueChanges.subscribe((obj) => {
            this.form.controls[this.controlName].hasError('required')
            this.updateContent(editor.contentDocument.body.textContent);
            this.updateContentLength(editor.contentDocument.body.textContent);
            if (obj == null || obj.length > 0) {
              this.toggleClassInEditorLabel();
            }
          })
          
            if (editor.contentDocument?.body.innerText.length > 1) {
              this.editTinymceStyles(editor.contentDocument.body);
              this.updateContentLength(editor.contentDocument.body.textContent);
              this.updateContent(editor.contentDocument.body.textContent);
            }
        })
        
        const allowedKeys = [8,46];
        editor.on('KeyDown', (event) => {
          this.updateContent(editor.contentDocument.body.textContent);
          
          if (this.isContentSelected && (allowedKeys.indexOf(event.keyCode) != -1)) {
            this.updateContentLength();
          }

          if (this.content.length + 1 > this.maxLength && (allowedKeys.indexOf(event.keyCode) == -1)) {
            event.stopPropagation();
            event.preventDefault();  
          }
        });
        
        editor.on('SelectionChange', (event) => {
          const selection = editor.selection.getContent({format: 'text'});
          this.isContentSelected = selection === this.content;
          this.toggleClassInEditorLabel();
        });

        editor.on('paste', (event) => {
          const clipboardContent = event.clipboardData.getData('text/plain');

          if (clipboardContent.length + this.contentLength > this.maxLength) {
            event.preventDefault();
            editor.insertContent(clipboardContent.substring(0, this.maxLength-this.contentLength));
            this.updateContentLength(editor.contentDocument.body.textContent);
          }
        });
      }
    };
  }

  ngAfterViewInit(): void {
    this.toggleClassInEditorLabel();
  }

  private updateContentLength(textContent = ''): void {
    this.contentLength = textContent.replace(/\ufeff/g, '').length ?? 0;
  }

  private updateContent(textContent: string): void {
    this.content = textContent.replace(/\ufeff/g, '');
  }

  private toggleClassInEditorLabel(): void {
    if (this.editorLabel?.nativeElement) {
      this.editorLabel.nativeElement.classList.toggle("pristine", this.contentLength > 0);
    }
  }

  private editTinymceStyles(element) {
    element.style.margin = "22px 16px";
  }

  ngOnDestroy(): void {
    this.service?.setInterceptTabChange(true);
  }

}
